import useAuth from "app/hooks/useAuth";

const usePermissions = () => {
  const { permissions } = useAuth();
  const permissionList = Array.isArray(permissions) ? permissions : [];
  const hasPermission = (permission) => {
    if (!permission) {
      return false;
    }
    if (Array.isArray(permission)) {
      return permission.some((p) => permissionList.includes(p));
    }
    return permissionList.includes(permission);
  };

  return { permissions: permissionList, hasPermission };
};

export default usePermissions;
